<template>
  <div>
    <interview-form-jp v-model="formData" v-if="formData.country === 1"></interview-form-jp>
    <interview-form-ko v-model="formData" v-if="formData.country === 2"></interview-form-ko>
  </div>
</template>
<script>
import interviewFormJp from './interviewFormJp';
import interviewFormKo from './interviewFormKo';

export default {
  components: {
    interviewFormJp,
    interviewFormKo
  },
  data() {
    return {
      formData: {
        country: 1,
        has_passport: '',
        port_num: '',
        native: '',
        home_telephone: '',
        japanese_major: '',
        art_exam: '',
        go_japan_num: '',
        leave: '',
        family_native_place: '',
        now_place: '',
        postal_code: '',
        email: '',
        korea_xuexin: '',
        korea_xuexin_password: '',
        apply_avescore: '',
        custom_year: '',
        custom_month: '',
        sex: '',
        brithday: '',
        marry: '',
        final_edu: '',
        final_time: '',
        final_school: '',
        final_subject: '',
        gaokao: '',
        gaokao_score: '',
        art_exam_score: '',
        general_exam: '',
        general_exam_score: '',
        born_place_area: null,
        born_place_city: null,
        etype: ''
      }
    };
  },
  methods: {
    async saveFormData(studentData) {
      // 保存报名表并将蓝火字段覆盖报名表
      if (this.formData.country) {
        const { data } = await this.$http._post({
          url: '/index/student/saveUserInterviewForm',
          data: {
            country: this.formData.country,
            formData: this.formData,
            studentData: studentData
          }
        });
        this.formData.update_time = data.update_time;
      }
    },
    async getInterviewFormData() {
      const { data } = await this.$http._post({
        url: '/index/student/getUserInterviewForm',
        data: { userId: this.$route.params.id }
      });
      this.formData = data;
    },
  },
  mounted() {
    this.getInterviewFormData();
  }
};
</script>
<style>
.width60 {
  width: 60px;
}
.width100 {
  width: 100px;
}
.width150 {
  width: 150px;
}
.width200 {
  width: 200px;
}
.width300 {
  width: 300px;
}
.row-gray {
  background: #dcdcdc;
}
</style>
